import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';
import type {
  UpholsteryDesignSettings,
  UpdateUpholsteryDesignSettings,
} from '@estimator/shared';

export function useUpholsteryDesignSettings() {
  return useQuery({
    queryKey: ['upholstery-design-settings'],
    queryFn: async () => {
      const { data } = await apiClient.get<UpholsteryDesignSettings>('/upholstery-design-settings');
      return data;
    },
  });
}

export function useUpdateUpholsteryDesignSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: UpdateUpholsteryDesignSettings) => {
      const { data } = await apiClient.patch<UpholsteryDesignSettings>(
        '/upholstery-design-settings',
        body,
      );
      return data;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['upholstery-design-settings'] }),
  });
}
